export default __webpack_public_path__ + "static/media/foodics-logo.d30a08c1.svg";